module.exports = __webpack_public_path__ + "static/media/21ECLAC25.61b7e91e.jpg";